import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.large};
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    zindex: 999;
    background-color: #eee;
    padding: 10px 20px 40px;
    border-radius: 8px;
    flex-direction: column;
  `}
`;

export const IconContainer = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.xLarge};
    text-align: center;
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.xLarge};
    text-align: center;
    color: ${theme.colors.darkGrey};
  `}
`;

export const SubTitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.meddium};
    text-align: center;
    margin-top: 1rem;
  `}
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: center;
  margin-top: 1rem;
  cursor: pointer;
`;
